import { render, staticRenderFns } from "./points-goods-order-sub.vue?vue&type=template&id=60139400&"
import script from "./points-goods-order-sub.vue?vue&type=script&lang=js&"
export * from "./points-goods-order-sub.vue?vue&type=script&lang=js&"
import style0 from "./points-goods-order-sub.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports